import { Link } from "react-router-dom";
import { Container } from "@components/ui/Container";
import { Button } from "@components/ui/Button";
import styles from "./NotFound.module.css";

export default function NotFound() {
  return (
    <div className={styles.wrap}>
      <Container size="narrow">
        <div className={styles.code} aria-hidden>
          404
        </div>
        <h1 className={styles.title}>Esta cobertura no la tenemos</h1>
        <p className={styles.body}>
          La página que buscás no existe o fue movida. Volvé al inicio o contactanos
          y te ayudamos a encontrar lo que necesitás.
        </p>
        <div className={styles.actions}>
          <Link to="/">
            <Button variant="cta">Volver al inicio</Button>
          </Link>
          <Link to="/contacto">
            <Button variant="secondary">Contactar</Button>
          </Link>
        </div>
      </Container>
    </div>
  );
}
